(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["client-stories-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('.cs-video');
    if (!section) return;

    var els = section.querySelectorAll('.cs-video__text, .cs-video__embed-wrap');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.15 });

    els.forEach(function (el) { observer.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    var select = document.getElementById('collection-sort');
    if (!select) return;
    select.addEventListener('change', function () {
      window.location.href = '{{ collection.url }}?sort_by=' + this.value;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collections"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var select = document.querySelector('[data-collection-filter]');
    var grid = document.querySelector('[data-product-grid]');
    var pagination = document.querySelector('[data-pagination]');
    var emptyMessage = document.querySelector('[data-empty-message]');
    if (!select || !grid) return;

    var cards = grid.querySelectorAll('.collection-card');

    select.addEventListener('change', function () {
      var target = select.value;
      var visibleCount = 0;

      cards.forEach(function (card) {
        var handles = (card.getAttribute('data-collections') || '').split(' ');
        var matches = target === 'all' || handles.indexOf(target) !== -1;
        card.hidden = !matches;
        if (matches) visibleCount += 1;
      });

      if (emptyMessage) emptyMessage.hidden = visibleCount !== 0;
      if (pagination) pagination.hidden = target !== 'all';
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    const header = document.querySelector('.site-header');
    const hamburger = document.querySelector('.site-header__hamburger');
    const mobileMenu = document.getElementById('mobile-menu');

    // Scroll shadow
    function onScroll() {
      header.classList.toggle('site-header--scrolled', window.scrollY > 8);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    // Mobile menu toggle
    if (hamburger && mobileMenu) {
      hamburger.addEventListener('click', function () {
        const isOpen = hamburger.getAttribute('aria-expanded') === 'true';
        hamburger.setAttribute('aria-expanded', String(!isOpen));
        mobileMenu.setAttribute('aria-hidden', String(isOpen));
        mobileMenu.classList.toggle('is-open', !isOpen);
      });
    }

    // Close currency dropdown when clicking outside
    document.addEventListener('click', function (e) {
      document.querySelectorAll('.site-header__currency[open]').forEach(function (el) {
        if (!el.contains(e.target)) el.removeAttribute('open');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["philosophy"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('.philosophy');
    if (!section) return;

    var header = section.querySelector('.philosophy__header');
    var phases = section.querySelectorAll('.philosophy__phase');

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.15 });

    if (header) observer.observe(header);

    phases.forEach(function (phase, i) {
      phase.style.transitionDelay = (i * 0.12) + 's';
      observer.observe(phase);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;

    var priceEl = document.querySelector('[data-product-price]');
    var compareEl = document.querySelector('[data-product-compare-price]');
    var availabilityEl = document.querySelector('[data-product-availability]');
    var submitBtn = form.querySelector('[data-add-to-cart]');
    var mainImage = document.querySelector('[data-gallery-main] img');

    function updateFromOption(option) {
      if (!option) return;
      var available = option.dataset.available === 'true';

      if (priceEl && option.dataset.price) priceEl.textContent = option.dataset.price;

      if (compareEl) {
        if (option.dataset.compareAtPrice) {
          compareEl.textContent = option.dataset.compareAtPrice;
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }

      if (availabilityEl) {
        availabilityEl.textContent = available ? 'In stock' : 'Sold out';
        availabilityEl.classList.toggle('is-available', available);
        availabilityEl.classList.toggle('is-unavailable', !available);
      }

      if (submitBtn) {
        submitBtn.disabled = !available;
        submitBtn.textContent = available ? submitBtn.dataset.addLabel : submitBtn.dataset.soldOutLabel;
      }

      if (mainImage && option.dataset.image) {
        mainImage.src = option.dataset.image;
      }
    }

    var select = form.querySelector('[data-variant-select]');
    if (select) {
      select.addEventListener('change', function () {
        updateFromOption(select.selectedOptions[0]);
      });
    }

    var qtyInput = form.querySelector('#quantity');
    var decreaseBtn = form.querySelector('[data-qty-decrease]');
    var increaseBtn = form.querySelector('[data-qty-increase]');

    if (qtyInput && decreaseBtn && increaseBtn) {
      decreaseBtn.addEventListener('click', function () {
        var value = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.max(1, value - 1);
      });
      increaseBtn.addEventListener('click', function () {
        var value = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = value + 1;
      });
    }

    var thumbs = document.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (mainImage && thumb.dataset.fullSrc) {
          mainImage.src = thumb.dataset.fullSrc;
        }
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
